import React, { forwardRef } from 'react';
import Table from '../../../../../../components/Common/Table';
import MultiSeriesLineChart from '../../../MultiSeriesLineChart';
import { View } from '../../../../../../components/Common/react-native-components';
import {
  buildMonthSeriesForMultiLineChart,
  convertCstDataIntoTableCompatible,
  convertCstDataIntoTableCompatibleTest,
  currentDateFormat,
  DATE_FORMAT_MAPPING,
  seprateDateAndNonDateColumns
} from '../../../../../../utils/transformChartsAndTableData';
import moment from 'moment';
import { CHART_COLORS } from '../../../../constants';
import GenericNoData from '../../../../../../components/Common/NoData/GenricNoData';

const ScoreBySource = forwardRef((props, ref) => {
  const { type, itemData, lowSampleSize } = props;

  if (!itemData?.cstData) {
    return <GenericNoData />;
  }


  const tableData = convertCstDataIntoTableCompatibleTest(itemData?.cstData || {});

  const notAllowedColumns = ['# of records'];
  const { columns = [], metric_data = [], rows = [] } = itemData?.cstData || {};

  let multiLineChartData = buildMonthSeriesForMultiLineChart(columns, rows, metric_data, CHART_COLORS);

  let finalData = multiLineChartData?.map((e, index) => {
    const rowData = tableData?.table_rows?.[index];
    return {
      ...e,
      label: {
        value: rowData?.total,
        label: 'Total Pecentage'
      },
      subLabel: {
        value: rowData?.benchmark_sample_size,
        label: 'Same Period Ago'
      }
    };
  })?.filter(e => !notAllowedColumns.includes(e.name));
  console.log(finalData)
  const chartCategories = seprateDateAndNonDateColumns(columns)?.dateFields?.map(e => {
    let dateFormat = currentDateFormat(e);
    return moment(e, dateFormat).format(DATE_FORMAT_MAPPING[dateFormat]);
  });
  function renderContent() {
    switch (type) {
      case 'BAR':
        return (
          <MultiSeriesLineChart
            ref={ref}
            widgetData={itemData}
            categories={chartCategories}
            chartType={'line'}
            data={finalData || []}
          />
        );
      case 'TIME':
        return (
          <MultiSeriesLineChart
            ref={ref}
            widgetData={itemData}
            categories={chartCategories}
            chartType={'column'}
            data={finalData || []}
          />
        );
      case 'TABLE':
        return (
          <View style={{ height: 'auto' }}>
            <Table lowSampleSize={lowSampleSize} table_data={tableData} expendable={false} />
          </View>
        );
    }
  }

  return <View>{renderContent()}</View>;
});

export default ScoreBySource;
